import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function documentValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
            return null;
        }
        const onlyNumbers = /^\d*$/.test(value);
        return !onlyNumbers ? { onlyNumber: true } : null;
    }
}